// extracted by mini-css-extract-plugin
export var btnPage = "referralCampaign-module--btnPage---80Ev";
export var activeOption = "referralCampaign-module--activeOption--5yh-7";
export var intro = "referralCampaign-module--intro--bEeZV";
export var content = "referralCampaign-module--content--cJA6F";
export var regulation = "referralCampaign-module--regulation--wH-O-";
export var lead = "referralCampaign-module--lead--PSspt";
export var text = "referralCampaign-module--text--alQPR";
export var formContainer = "referralCampaign-module--formContainer--9om-Q";
export var option = "referralCampaign-module--option--xh3ft";
export var formGroup = "referralCampaign-module--formGroup--5GKSa";
export var checkbox = "referralCampaign-module--checkbox--gXck7";
export var checked = "referralCampaign-module--checked--tnuSK";
export var submit = "referralCampaign-module--submit--TvyZa";
export var login = "referralCampaign-module--login--o+u8m";
export var prizes = "referralCampaign-module--prizes--7OA71";
export var enterprises = "referralCampaign-module--enterprises--8Y1A2";